const billingSupplierConfigSchema = function (state, props) {
  return {
    "ui:order": [
      "name", "vatId", "enterpriseNumber",
      "addressLine", "postalCode", "city", "countryCode",
      "iban", "email", "phone",
      "peppolId", "peppyrusApiKey",
      "invoiceMessage", "invoiceConditions",
      "*"
    ],
    "name":              { "ui:options": { width: 8 } },
    "vatId":             { "ui:options": { width: 4 } },
    "enterpriseNumber":  { "ui:options": { width: 4 } },
    "addressLine":       { "ui:options": { width: 12 } },
    "postalCode":        { "ui:options": { width: 4 } },
    "city":              { "ui:options": { width: 6 } },
    "countryCode":       { "ui:options": { width: 2 } },
    "iban":              { "ui:options": { width: 8 } },
    "email":             { "ui:options": { width: 8 } },
    "phone":             { "ui:options": { width: 4 } },
    "peppolId":          { "ui:options": { width: 8 } },
    "peppyrusApiKey":    { "ui:options": { width: 8 } },
    "invoiceMessage":    {
      "ui:widget": "textarea",
      "ui:options": { width: 16, rows: 3 }
    },
    "invoiceConditions": {
      "ui:widget": "textarea",
      "ui:options": { width: 16, rows: 3 }
    }
  }
}

export default billingSupplierConfigSchema
